import { defineStore } from 'pinia';

export const eigenaarStore = defineStore({
  id: 'eigenaar',
  state: () => ({
    aantalschuldschaden: '',
    achternaam: '',
    adres: '',
    akkoordincasso: '',
    banned: 0,
    bedrijfsnaam: '',
    betalingswijze: 'AutomatischeIncasso',
    emailadres: '',
    relatie: '',
    relatie_toelichting: '',
    geboortedatum: null,
    geslacht: '',
    huisnummer: '',
    iban: '',
    is_eigenaar: '1',
    is_kentekenhouder: '0',
    telefoonnummer: '',
    kvk: '',
    postcode: '',
    rijbewijs: '',
    straat: '',
    toevoeging: '',
    toevoegingenOpties: [],
    tussenvoegsels: '',
    voorletters: '',
    woonplaats: '',
    addressNotFound: false,
  }),
  getters: {},
  actions: {},
  persist: true,
});
